module.exports = __webpack_public_path__ + "static/media/emptyExam.303b5d65.png";